import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';

export default class AssortmentDriveItemListPage extends AbstractDriveItemListPage {

	headerLabel = 'messages.assortment';
	noItemsLabel = 'messages.no_assortment';

	initializeView(props: AbstractDriveItemListPageProps): void {
		return;
	}

	getDriveItemIds(): number[] {
		const { originParam } = this.props.params;
		return originParam ? originParam.split(',').map(id => parseInt(id, 10)) : [];
	}

	renderAdditionalItems(): JSX.Element[] | null {
		return null;
	}

	getAdditionalItemsLength(): number {
		return 0;
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/Assortment.tsx